import { render, staticRenderFns } from "./LessonPlayer.vue?vue&type=template&id=2d390aa2&scoped=true"
import script from "./LessonPlayer.vue?vue&type=script&lang=js"
export * from "./LessonPlayer.vue?vue&type=script&lang=js"
import style0 from "./LessonPlayer.vue?vue&type=style&index=0&id=2d390aa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d390aa2",
  null
  
)

export default component.exports